import React from "react";
import {
  OverLayBackGround,
  OverLayContainer,
} from "./style";
import back from "../../../assets/svgs/back.svg";

export type OverLayProps = {
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void; // to handle onClick functions
  children?: React.ReactNode; // make the component able to receive children elements
  isOpen: boolean; //value to set Overlay visibility
  onClose: () => void;
};

const Overlay = ({ isOpen, onClose, children }: OverLayProps) => {
  return (
    <>
      {isOpen && (
        <>
          <OverLayBackGround>
            <OverLayContainer>
                {children}
                <button
                  className="bg-transparent border-none text-lg cursor-pointer text-otaku-red-1  font-bold after:inline-block absolute right-6 top-4"
                  onClick={onClose}
                >
                  <img src={back} alt="back" />
                </button>
            </OverLayContainer>
          </OverLayBackGround>
        </>
      )}
    </>
  );
};

export default Overlay;
